import { ZAttrItemProps } from "src/common/attrEdit";
import { flattenObjectValues } from "src/common/flattenObjectValues";

export type TooltipMode = "ext" | "none" | "text";
export const getTooltipMode = (itemProps: ZAttrItemProps): TooltipMode => {
  const hasExtData = flattenObjectValues(itemProps.tooltipExt ?? {}).some(
    Boolean,
  );
  if (hasExtData) return "ext";
  return itemProps.tooltip ? "text" : "none";
};
